module.exports = __webpack_public_path__ + "static/img/arrow2.e0015c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow2.png
// module id = mzkm
// module chunks = 94